export const ASSETS = {
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_b6d9bace-8f37-4897-95f0-917622b3412b/artifacts/9aogw76r_WhatsApp%20Image%202026-07-27%20at%205.21.36%20PM.webp",
  ceo: "https://customer-assets-rejwkqb3.emergentagent.net/job_b6d9bace-8f37-4897-95f0-917622b3412b/artifacts/bzrdm18g_Gemini_Generated_Image_1fop131fop131fop.webp",
  hero: "https://images.pexels.com/photos/5506026/pexels-photo-5506026.jpeg",
  artillery: "https://images.unsplash.com/photo-1545631757-8b75025a310e",
  worldMap: "https://images.unsplash.com/photo-1562504208-03d85cc8c23e",
  welding:
    "https://images.unsplash.com/photo-1564182998523-6923112e7d6b?crop=entropy&cs=srgb&fm=jpg&q=85",
  pipeline:
    "https://images.unsplash.com/photo-1593583810872-ddee4d6bd55a?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const COMPANY = {
  short: "DAIS",
  name: "Defense Artillery Inspection Services",
  legal: "DAIS INSPECTIONS",
  tagline: "Your Brand, Powered by Our People.",
  certification: "An ISO 9001:2015 Certified Company",
  website: "www.daisrecruitments.com",
  phones: ["09326590693", "09604312574"],
  whatsapp: "https://wa.me/919604312574",
  linkedin: "https://www.linkedin.com/",
  emails: [
    "yogesh.rane@daisrecruitments.com",
    "inspection@daisrecruitments.com",
    "hradmin@daisrecruitments.com",
  ],
  registeredOffice:
    "Uddan Avenue, 203, Near neral station, Neral East 410101, Raigad, Maharashtra.",
  corporateOffice:
    "Office no. 3, First Floor, Ashwin keerti tower, Badlapur, 410503, Thane, Maharashtra.",
};

export const PROFILE =
  "Our business involved in Second- and third-party inspection services, expediting services, Welding and NDT Consultancy services, Inspection of painting, coating, insulation services, inspection of production process, pre-shipment, vendor evaluation, provide shutdown experts and employment placement services. Expert in recruit the right person for right job. We have network in worldwide about engineering expert executives who is having good quality of experience in engineering fields. Our core strength in Defense artillery equipment inspection, testing and commissioning.";

export const MISSION =
  "To develop an expert manpower chain to resolve any engineering obstacles within a fraction of time.";

export const VISION =
  "To become a world class Third party inspection services and manpower consultant in engineering field.";

export const QUALITY_POLICY =
  "We contribute to develop and maintain quality Culture of the organisation we serve.";

export const VALUES = "Be True, Be Passionate, Be Responsible";

export const REGISTRATIONS = ["MSME", "ISO 9001:2015", "GST", "IEC — Import Export Code Licence"];

export const SERVICES = [
  {
    icon: "ClipboardCheck",
    title: "Second- & Third-Party Inspection",
    body: "DAIS Quality Services has qualified Inspectors to carryout Third Party Inspection as per approved Quality Assurance Plan, Inspection and Test Plan, in accordance with International Codes and Standards.",
  },
  {
    icon: "Truck",
    title: "Expediting Services",
    body: "DAIS Expeditors are highly qualified and well experienced with specification criteria. Our expeditors interact with the client to establish the specific requirements to ensure that all the stages of the projects are accomplished as per planned schedule.",
  },
  {
    icon: "Flame",
    title: "Welding & NDT Consultancy",
    body: "Welding and NDT inspection services, technical consultancy services, auditing services and procedure qualification services delivered by certified specialists.",
  },
  {
    icon: "PaintRoller",
    title: "Painting, Coating & Insulation",
    body: "Inspection of painting, coating and insulation services carried out to approved quality assurance plans and international standards.",
  },
  {
    icon: "PackageSearch",
    title: "Production Process & Pre-Shipment",
    body: "Inspection of production process pre-shipment, vendor evaluation and sourcing, plus expediting visit and supplier surveillance audit.",
  },
  {
    icon: "Users",
    title: "Placement & Shutdown Experts",
    body: "Employment placement services, shutdown experts and international freelancing inspectors. Expert in recruit the right person for right job.",
  },
];

export const MANPOWER = [
  {
    icon: "UserCheck",
    title: "Permanent Staffing / Recruitment",
    category: "Manpower & HR",
    body: "We help organizations hire expert full-time talent for middle, senior and top level positions across diverse sectors. We extensively screen candidates that saves our clients valuable management time in the interviewing process and helps them hire top talent.",
  },
  {
    icon: "Clock",
    title: "Temporary / Contracting Staffing",
    category: "Manpower & HR",
    body: "Our Contract Staffing Services allows organizations the ease and flexibility to scale their workforce based on demand. It also helps organizations onboard niche skills to their workforce for short duration workloads at the most competitive cost.",
  },
  {
    icon: "UserPlus",
    title: "Temp to Hire Solution",
    category: "Manpower & HR",
    body: "Our Temp-to-Hire services allow organizations the opportunity to evaluate a candidate over a period of time before on-boarding the candidate at the end of the contract period — determining not just competency but also cultural and behavioral fit.",
  },
  {
    icon: "Users",
    title: "Overstaffing & Flexi-Workforce",
    category: "Manpower & HR",
    body: "We help organizations to be far more agile, nimble and flexible with our temporary contract staffing services. We hire the employees on our rolls so you can have a flexi-workforce at your disposal. Upscale or downscale as per your business needs.",
  },
  {
    icon: "GraduationCap",
    title: "On Boarding & Training",
    category: "Manpower & HR",
    body: "Recruitment is only half the job done. As a part of our manpower staffing services we manage the joining formalities, induct talent, and prepare them for action at work.",
  },
  {
    icon: "Briefcase",
    title: "Management Services",
    category: "Manpower & HR",
    body: "Resource management, HR solution, leadership assessment, project management, payroll system, employees time and administration cost management.",
  },
];

export const STRENGTHS = [
  {
    icon: "Target",
    title: "RIGHT TALENT",
    body: "Our expert and trained recruiters source the right-match candidates so that you don't waste time screening and interviewing irrelevant profiles. We pride ourselves with a 99% success rate for the profiles we source.",
  },
  {
    icon: "Timer",
    title: "RIGHT TIME",
    body: "With a curated pool of pre-screened talent, we help you onboard the right talent within the shortest possible time.",
  },
  {
    icon: "BadgeIndianRupee",
    title: "RIGHT COST",
    body: "Hire talent without any risk. All our terms are very competitive and as per standard industry norms.",
  },
];

export const SECTORS = [
  { icon: "Shield", name: "Defense and Aerospace" },
  { icon: "Fuel", name: "Oil and Gas" },
  { icon: "Zap", name: "Power plants" },
  { icon: "Building2", name: "Infrastructures" },
  { icon: "RadioTower", name: "Electronics and telecommunication" },
  { icon: "Car", name: "Automobile Industries" },
  { icon: "Ship", name: "Ship building and Constructions" },
];

export const COUNTRIES = [
  { name: "USA", calls: "400+" },
  { name: "Germany", calls: "500+" },
  { name: "Italy", calls: "100+" },
  { name: "Sweden", calls: "150+" },
  { name: "Greece", calls: "100+" },
  { name: "Netherland", calls: "200+" },
  { name: "Norway", calls: "100+" },
  { name: "France", calls: "500+" },
  { name: "UK", calls: "300+" },
  { name: "Bangladesh", calls: "200+" },
  { name: "China", calls: "500+" },
  { name: "Japan", calls: "200+" },
  { name: "Kuwait", calls: "100+" },
  { name: "Mongolia", calls: "20+" },
  { name: "Myanmar", calls: "50+" },
  { name: "Sri Lanka", calls: "50+" },
  { name: "S. Korea", calls: "500+" },
  { name: "Switzerland", calls: "100+" },
  { name: "Taiwan", calls: "50+" },
];

export const EQUIPMENT = [
  "Butterfly Valve",
  "Exhauster",
  "Compactor",
  "Gear box",
  "Valve testing",
  "Control Cables",
  "SS Tubes",
  "Control Panels",
  "Knife gate valve",
  "Stoplog Frame",
  "Submar. Pump",
  "240 KVA Trans.",
  "Heat Exchanger",
  "Storage Tank",
  "Flanges",
  "Stair Structure",
];

export const CEO = {
  name: "Mr. Yogesh D. Rane",
  role: "CEO / Managing Director",
  credentials:
    "PMP Certified, MBA in Operation research and B. Tech in Mechanical engineering. PhD Pursuing in International Business, ID No.12003456.",
  bio: "Having more than two decades of work experience in inspection, testing, vendor development, process development and Project coordination. Technical staff recruitments, training and administration. Visited in many countries and PAN India for inspection and Shop Audit purpose.",
  highlight:
    "Previously we have done prestigious project under the Centre's 'Make in India' initiative of defense K9 Vajra guns for the Indian army on behalf of L&T Defense and LR.",
  closing:
    "We are an efficient resource, enabling companies to recruit and manage flexible and permanent talent in order to enhance quality, productivity and minimizing companies employment related risks. We provide valuable support like personnel administration, labor compliance, and government regulations related to hiring, while you acquire a quality employee service.",
};

export const NAV_LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Core Strengths", href: "#core-strengths" },
  { label: "Leadership", href: "#leadership" },
  { label: "Contact", href: "#contact" },
];
